import type { TimelineItemSubcategoryEnum } from "web_myplann/Infrastructure/Api/Api";
import { DOCUMENT_FILTER_SUBCATEGORIES } from "web_myplann/NotificationCenter/Atoms/timelineFilterAtom";
import { isDocumentsOnlyActive } from "web_myplann/NotificationCenter/Utils/isDocumentsOnlyActive";

export interface DocumentsOnlyFilter {
	documentsOnly: boolean;
	subcategories: TimelineItemSubcategoryEnum[] | undefined;
}

export const resolveDocumentsOnlyFilter = (
	flag: boolean | undefined,
	hasDocumentsFeature: boolean,
): DocumentsOnlyFilter => {
	const documentsOnly = isDocumentsOnlyActive(flag, hasDocumentsFeature);
	return {
		documentsOnly,
		subcategories: documentsOnly ? DOCUMENT_FILTER_SUBCATEGORIES : undefined,
	};
};
